import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MdlDialogService, IMdlCustomDialogConfiguration } from '@angular-mdl/core';
import { KitInventoryDetailComponent, KIT_DETAIL_TOKEN } from '../../investigator/kitinventory/kit-inventory-detail.component';
import { KitInfoGridRowItem } from '../../investigator/kitinventory/kit-grid-row';

@Component({
    selector: 'detail-modal-popup-renderer',
    template: require('./detail-modal-popup-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailModalPopupAgRendererComponent {
    public row: KitInfoGridRowItem;

    constructor(private readonly dialogService: MdlDialogService) {
    }

    public agInit(row: KitInfoGridRowItem) {
        this.row = row;
    }

    private showDetail($event: any) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: KitInventoryDetailComponent,
            providers: [{
                provide: KIT_DETAIL_TOKEN, useValue: this.row.data
            }],
            isModal: true,
            clickOutsideToClose: true,
            classes: 'detail-scrollable'
        };

        this.dialogService.showCustomDialog(configDialog);
    }
}